<template>
  <div class="file-uploader">
    <input type="file"
           ref="fileInput"
           @change="upload"
           hidden />
    <button class="file-uploader-btn btn btn-sm btn-extra-round "
            :class="style"
            @click="$refs.fileInput.click()">
      {{label || this.$t('message.campaigns.message.selectFile')}}
    </button>
  </div>
</template>

<script>
import uploadsBackground from "@mixins/uploads-background";
import EventBus from "@packages/event-bus";

export default {
  props: {
    dataId: {
      type: Number,
      required: true,
    },
    dataParentId: {
      required: true,
    },
    dataLocation: {
      type: String,
      required: false,
    },
    isMobile: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      required: false,

    },
    isPrimaryButton: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    style() {
      if (this.dataLocation === "INTERACTION" || this.isPrimaryButton) return "btn-primary text-sm";

      if (this.dataLocation === "PANEL") return "btn-secondary";

      return null;
    },
  },

  methods: {
    async upload() {
      const MAX_MB = 3
      const fileSize = MAX_MB * 1024 * 1024

      if (this.$refs.fileInput.files[0].size > fileSize) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: this.$t("message.errorMessages.message.fileToBig") + "3MB",
        });
        return;
      }
      await this.uploadBackground({
        interactionId: this.dataId,
        advertisingId: this.dataParentId,
        file: this.$refs.fileInput.files[0],
        isMobile: this.isMobile,
      });
    },
  },

  mixins: [uploadsBackground],
};
</script>

<style lang="scss" scoped>
.file-uploader {
  .file-uploader-btn {
    font-size: 14px;
  }
}
</style>
